import { render } from "./Semidark.vue?vue&type=template&id=2dfe6b93"
import script from "./Semidark.vue?vue&type=script&lang=js"
export * from "./Semidark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__